var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.726,
    height: 33.726,
    viewBox: "0 0 33.726 33.726",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dollar-symbol",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M16.863,0A16.863,16.863,0,1,0,33.726,16.863,16.863,16.863,0,0,0,16.863,0Zm1.021,24.375v1.952a.522.522,0,0,1-.542.526h-1.3a.53.53,0,0,1-.551-.526v-1.78a11.17,11.17,0,0,1-3.32-.658,1.042,1.042,0,0,1-.64-1.232l.212-.826a1.043,1.043,0,0,1,1.387-.713,8.373,8.373,0,0,0,3,.582c1.4,0,2.356-.54,2.356-1.522,0-.933-.785-1.522-2.6-2.136-2.626-.884-4.425-2.111-4.425-4.492,0-2.16,1.529-3.853,4.142-4.369V7.4a.586.586,0,0,1,.566-.578h1.3a.555.555,0,0,1,.529.578V9.007a9.69,9.69,0,0,1,2.657.443,1.046,1.046,0,0,1,.693,1.25l-.186.74a1.041,1.041,0,0,1-1.347.727,7.515,7.515,0,0,0-2.48-.41c-1.6,0-2.111.688-2.111,1.375,0,.81.859,1.325,2.946,2.111,2.921,1.031,4.094,2.381,4.094,4.589C22.258,22.018,20.714,23.884,17.884,24.375Z",
    transform: "translate(0)",
    fill: "#38953e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsd);
export default __webpack_public_path__ + "static/media/usd.6ed21bc3eb74e8ada953d0a1ac129f08.svg";
export { ForwardRef as ReactComponent };